import axios, { AxiosRequestConfig } from 'axios';
import { AllSaleOrdersTrackResponseModel, AllSoItemsResponseModel, SaleOrderDetailViewInfoResponseModel, SaleOrderDetailViewResponseModel, SaleOrderDto, SaleOrderResponse, SoViewResponseModel, AllSaleOrdersResponseModel, SODto, SaleOrderStatusDropdownResponseModel, SaleOrderStatusDropdownDto, SaleOrderFileUploadResponse, SaleOrderDropDownResponseModel, SaleOrderDetailsResponse, BomPackingItemsDto, SaleOrderInfoResponseModel, BomDetailsForIdResponseModel, GetAllBomDetailsResponseModel, GetAllBomDataResponseModel, SoRequest, CreateBomDTO, BOMDetailViewResponse, SaleOrderDropDownDto, SaleOrderFewDetailsDto, AllSaleOrdersDetailsResponseModel, AllSaleOrdersItemsDetailsResponseModel, BomUpdateRequest, ItemsDetailsResponseModel, PlantInvoiceDetailsResponse, PlantInvoiceDetailsRequest, GetAllInvoiceDetailsResponse, BomItemActiveResponse, AllInsuranceResponse, SoNumbersResponseModel, UpdateBomItemDto, BomItemRemovedQty, ActiveSaleOrderWithItemDetailsResponseModel, GetSaleOrderInformationResponseModel, SoTrackResponseModel, SoInspectionResponseModel, SoInspectionUpdateResponse, UpdateSoInspectionRequest, RmBomResponse, RmBomDto, SaleOrderItemsDropDownResponseModel, SoProductionResponseModel, SaleOrderItemsForSoDropDownResponseModel, SaleOrderItemsBySoIdReaponseModel, CommonResponse, SaleOrderNoRequest, saleOrderItemIdRequest, SoItemVariantResponse, PoNumberDropDownResponse, HlPercentageInfo, BomWithCountAndQuantityResponse, CountRequest, ProductIdRequest, SaleOrderProductIdRequest, SaleOrderIdsRequest, SoDropCntQtyResponse, SaleOrderItemsDropdownResponse, DummyPackBomItemsRequest, DocumentApprovalUpdateRequest, BomDetailsCreationResponseModel, PoBomInfo, GrossWeightRequest, ItemsDetails, BomTrackerForSoIdResponseModel, SgsTuvUpdateRequest, BomIdsRequest, SoTranferDto, GradePatternRequest, SoPackingStatusModel, SoPackingStatusRequest, UpdateCasesRequest, SubJobRequest, SaleOrderItemsDetailsResponseModel, TransferredSosFilterDto, ProductBarcodeRequest, SubJobSoIdRequest, SoTypeReq, DomesticSalesResponseModel, DomesticSalesModel, ConditionsRequest, InvoiceRequest, ShippedDateRequest, ProductGradeReportReq, OverDuePendingReq, scheduleOrderReport, ProductWiseTargetStockReq, ProductWiseStockReq } from '@gtpl/shared-models/sale-management';
import connection from './connection';
import { ItemRequest, saleOrder, SaleOrderItemsCasesRequest, SaleOrderItemsRequest, SaleOrderNumberRequest, SaleOrderTrackFilters, SoItemReq, SoLifeCycleStatusCategoryReq, SoProcessTypeREQ, StoreConsumptionItemsRequest } from './saleorder-model';
import { ItemCategoriesDropDownResponseModel, PlantIdRequest, BrandsRequest } from '@gtpl/shared-models/masters';
import { AllBlStatusInfo, AllContainerStatusInfo, ContainerStatusInfo, DispatchedToPlant, DocumentsApprovalResponse, DocumentsUploadData, FileUploadResponse, GetAllDocApprovalResponse, InvoiceDto, marksAndNoReq, PlantInvoiceCreateResponse, SoContainerStatusUpdate, UpdateDocumentStatusRequest } from '@gtpl/shared-models/logistics';
import { BomIdRequest } from './bom-id-request';
import { ReProcessRequiredQty } from './re-processing-required-qty.request';
import { FGStockData, ReprocessingBOMUpdateRequset, SaleOrderIdRequest, ShipmentDetailRequest, SoIdRequest, SOVarientIdReq } from '@gtpl/shared-models/warehouse-management';
import { SoProductionDTO, SORmBomResponse, SaleOrderItemsInfo, SgsTuvDto } from '@gtpl/shared-models/sale-management';
import { PayablesDashboardReq, PlantRequest, RMFiltersRequest } from '@gtpl/shared-models/raw-material-procurement';
import { EndCustomerReq, PackingRequiredResponse, SoComparisonDetailsResponse, SoCountDetailResponse, SoDeadStockDetailsResponse, SoLongRunResponse, SoProductCompleteNotShippedResponse, SoProductionStatusDetailsResponse, SoQntDetailResponse, SoStatusEnum, SoTopFiveResponse, SoYearWisePlanningDetailsResponse, SoYearWiseShippedDetailsResponse, UnitRequest, UserDateRequest, } from '@gtpl/shared-models/common-models';
import { EtdWiseDTO, LocationUpdateRequest, PackingBomFilter, ProductConversionReq, RequiredPackingResponse } from '@gtpl/shared-models/procurement-management';
import {DutyDrawBackDateReq, DutyDrawBackReportReq, PaymentReq, RodteStatusReq, SaleReceiveReq} from '@gtpl/shared-models/finance'
import {PaybleComponentReq} from '@gtpl/shared-models/analytics-data'

export class SaleOrderService {
    URL = connection.DEPLOY_URL + '/saleorder';


    async createSaleOrder(saleOrderDto: SaleOrderDto | any): Promise<CommonResponse> {
        console.log(this.URL)
        return await axios.post(this.URL + '/createCreateSaleOrder', saleOrderDto)
            .then(res => {
                return res.data
            })
    }

    async saleOrderFileUpload(file: any): Promise<SaleOrderFileUploadResponse> {
        return await axios.post(this.URL + '/saleOrderFileUpload', file)
            .then(res => {
                return res.data
            })
    }


    async updateSGSTUVData(req: SgsTuvDto): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateSGSTUVData', req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async updateBomQty(req: BomUpdateRequest): Promise<boolean> {
        return await axios.post(this.URL + '/updateBomQty', req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async updateSoTrackPmStatus(req: SoRequest): Promise<boolean> {
        return await axios.post(this.URL + '/updateSoTrackPmStatus', req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }
    async updateSoTrackProdStatus(req: SaleOrderIdRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateSoTrackProdStatus', req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }



    async UpdateAssignedQty(req: BomUpdateRequest): Promise<boolean> {
        return await axios.post(this.URL + '/UpdateAssignedQty', req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }




    async updateSaleOrder(saleOrderDto: SaleOrderDto): Promise<SaleOrderResponse> {
        console.log(this.URL)

        return await axios.post(this.URL + '/updateSaleOrder', saleOrderDto)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }
    async getAllSaleOrders(): Promise<AllSaleOrdersResponseModel> {
        return await axios.post(this.URL + '/getAllSaleOrders')
            .then(res => {
                return res.data
            })
    }
    async getAllSaleOrdersFHDashbard(req: UnitRequest): Promise<AllSaleOrdersDetailsResponseModel> {
        return await axios.post(this.URL + '/getAllSaleOrdersFHDashbard', req)
            .then(res => {
                return res.data
            })
    }

    async getAllSaleOrdersDetails(): Promise<AllSaleOrdersDetailsResponseModel> {
        return await axios.post(this.URL + '/getAllSaleOrdersDetails')
            .then(res => {
                return res.data
            })
    }

    async getAllBomTrackerInfo(req?: UnitRequest): Promise<AllSaleOrdersDetailsResponseModel> {
        return await axios.post(this.URL + '/getAllBomTrackerInfo', req)
            .then(res => {
                return res.data
            })
    }

    async getAllNotClosedSaleOrdersDetails(): Promise<AllSaleOrdersDetailsResponseModel> {
        return await axios.post(this.URL + '/getAllNotClosedSaleOrdersDetails')
            .then(res => {
                return res.data
            })
    }

    async getAllClosedSaleOrdersDetails(req: UnitRequest): Promise<AllSaleOrdersDetailsResponseModel> {
        return await axios.post(this.URL + '/getAllClosedSaleOrdersDetails', req)
            .then(res => {
                return res.data
            })
    }

    async getSaleOrdersDropDownList(): Promise<SaleOrderDropDownResponseModel> {
        return await axios.post(this.URL + '/getSaleOrdersDropDownList')
            .then(res => {
                return res.data
            })
    }
    async getPackingSaleOrders(): Promise<SaleOrderDropDownResponseModel> {
        return await axios.post(this.URL + '/getPackingSaleOrders')
            .then(res => {
                return res.data
            })
    }
    async getSaleOrdersForProduct(req: ProductIdRequest): Promise<SaleOrderDropDownResponseModel> {
        return await axios.post(this.URL + '/getSaleOrdersForProduct', req)
            .then(res => {
                return res.data
            })
    }

    async getAllActiveSaleOrders(req: PlantRequest): Promise<SaleOrderDropDownResponseModel> {
        return await axios.post(this.URL + '/getAllActiveSaleOrders', req)
            .then(res => {
                return res.data
            })
    }
    async getDummySaleOrders(req: PlantRequest): Promise<SaleOrderDropDownResponseModel> {
        return await axios.post(this.URL + '/getDummySaleOrders', req)
            .then(res => {
                return res.data
            })
    }
    async getMTOSaleOrders(req: PlantRequest): Promise<SaleOrderDropDownResponseModel> {
        return await axios.post(this.URL + '/getMTOSaleOrders', req)
            .then(res => {
                return res.data
            })
    }
    async getSaleOrderInformationById(saleOrderId: saleOrder): Promise<GetSaleOrderInformationResponseModel> {
        return await axios.post(this.URL + '/getSaleOrderInformationById', saleOrderId)
            .then(res => {
                return res.data
            })
    }
    //   async activatedeActivateSaleOrder(
    //     saleOrderDto: SODto
    //   ): Promise<SaleOrderResponse> {
    //     //   console.log(State.stateCode);
    //     return await axios
    //       .post(this.URL + '/updateSaleOrderStatus', saleOrderDto)
    //       .then((res) => {
    //         return res.data;
    //       });
    //   }
    async getAllSaleOrderItems(): Promise<AllSoItemsResponseModel> {
        return await axios.post(this.URL + '/getAllSaleOrderItems')
            .then(res => {
                return res.data
            })
    }

    async getAllSaleOrderItemDetails(Req?: saleOrder): Promise<AllSoItemsResponseModel> {
        return await axios.post(this.URL + '/getAllSaleOrderItemDetails', Req)
            .then(res => {
                return res.data
            })
    }

    async getSoItemDetailsForInProgress(Req: saleOrder): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getSoItemDetailsForInProgress', Req)
            .then(res => {
                return res.data
            })
    }
    async getSoItemDetailsForBackLog(Req: saleOrder): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getSoItemDetailsForBackLog', Req)
            .then(res => {
                return res.data
            })
    }

    async getSoViewDetails(selectedCustomer: number, selectedEndCustomer: number, selectedSaleOrder: number, selectedStatus: number, selectedExpectedDate: any): Promise<any> {
        return await axios.post(this.URL + '/SoViewDetails', { selectedCustomer, selectedEndCustomer, selectedSaleOrder, selectedExpectedDate })
            .then(res => {
                return res.data
            })
    }

    async getSaleorderDataById(saleOrderId: saleOrder): Promise<SaleOrderResponse> {
        return await axios.post(this.URL + '/getSaleOrderDataById', saleOrderId)
            .then(res => {
                return res.data
            })
    }


    async getSaleOrderDetailsById(saleOrderId: saleOrder): Promise<SaleOrderDetailViewInfoResponseModel> {
        return await axios.post(this.URL + '/getSaleOrderDetailsById', saleOrderId)
            .then(res => {
                return res.data
            })
    }
    async getSaleOrderDetailsBySaleNumber(saleOrderNumberRequest: SaleOrderNumberRequest): Promise<SaleOrderDetailViewInfoResponseModel> {
        return await axios.post(this.URL + '/getSaleOrderDetailsBySaleNumber', saleOrderNumberRequest)
            .then(res => {
                return res.data
            })
    }

    async getAllSaleOrdersTrackData(saleOrderTrackFilters: SaleOrderTrackFilters): Promise<AllSaleOrdersTrackResponseModel> {
        return await axios.post(this.URL + '/getAllSaleOrdersTrackData', saleOrderTrackFilters)
            .then(res => {
                return res.data
            })
    }
    async getAllSaleOrdersTrackDataNew(saleOrderTrackFilters: SaleOrderTrackFilters): Promise<AllSaleOrdersTrackResponseModel> {
        return await axios.post(this.URL + '/getAllSaleOrdersTrackDataNew', saleOrderTrackFilters)
            .then(res => {
                return res.data
            })
    }
    async getStatusList() {
        return new SaleOrderStatusDropdownResponseModel(true, 11, 'itemsData retrived successfully', [new SaleOrderStatusDropdownDto('OPEN'), new SaleOrderStatusDropdownDto('INPROGRESS'), new SaleOrderStatusDropdownDto('CLOSED'), new SaleOrderStatusDropdownDto('CANCELLED')])
    }


    /**
     * get sale order details for sale order id
    */
    async getSaleOrderDetailsForId(saleOrderId: saleOrder): Promise<SaleOrderDetailsResponse> {
        return await axios.post(this.URL + '/getSaleOrderDetailsForId', saleOrderId)
            .then(res => {
                return res.data
            })
    }




    async getPmStatus(saleOrderId: saleOrder): Promise<any> {
        return await axios.post(this.URL + '/getPmStatus', saleOrderId)
            .then(res => {
                return res.data
            })
    }




    /**
     * get sale order item details for sale order id
     * @param saleOrderId 
     * @returns 
     */
    async getSaleOrderInformation(saleOrderId: saleOrder): Promise<SaleOrderInfoResponseModel> {
        return await axios.post(this.URL + '/getSaleOrderInformation', saleOrderId)
            .then(res => {
                return res.data
            })
    }

    async updateReportingCases(saleOrderItemsCasesRequest: SaleOrderItemsCasesRequest): Promise<SaleOrderInfoResponseModel> {
        return await axios.post(this.URL + '/updateReportingCases', saleOrderItemsCasesRequest)
            .then(res => {
                return res.data
            })
    }

    async getPlantInvoiceDetails(plantInvoiceDetailsRequest: PlantInvoiceDetailsRequest): Promise<PlantInvoiceDetailsResponse> {
        return await axios.post(this.URL + '/getPlantInvoiceDetails', plantInvoiceDetailsRequest)
            .then(res => {
                return res.data
            })
    }

    async getInvoiceDetailsForPrint(plantInvoiceDetailsRequest: PlantInvoiceDetailsRequest): Promise<PlantInvoiceDetailsResponse> {
        return await axios.post(this.URL + '/getInvoiceDetailsForPrint', plantInvoiceDetailsRequest)
            .then(res => {
                return res.data
            })
    }



    async saveBomPackingMaterialDetails(bomData: CreateBomDTO) {
        return await axios.post(this.URL + '/saveBomPackingMaterialDetails', bomData)
            .then(res => {
                return res.data
            })
    }

    async getAllBomDetailsForSoId(saleOrderId: saleOrder): Promise<BomDetailsForIdResponseModel> {
        return await axios.post(this.URL + '/getAllBomDetailsForSoId', saleOrderId)
            .then(res => {
                return res.data
            })
    }
    async getAllBomDetailsBySoId(saleOrderId: saleOrder): Promise<ItemCategoriesDropDownResponseModel> {
        return await axios.post(this.URL + '/getAllBomDetailsBySoId', saleOrderId)
            .then(res => {
                return res.data
            })
    }

    async getBomItemsForSoId(saleOrderId: saleOrder): Promise<BomTrackerForSoIdResponseModel> {
        return await axios.post(this.URL + '/getBomItemsForSoId', saleOrderId)
            .then(res => {
                return res.data
            })
    }

    async getAllBomDetailViewDataForSoId(saleOrderId: saleOrder): Promise<BOMDetailViewResponse> {
        return await axios.post(this.URL + '/getAllBomDetailViewDataForSoId', saleOrderId)
            .then(res => {
                return res.data
            })
    }

    async createPlantInvoice(invoiceDto: InvoiceDto): Promise<PlantInvoiceCreateResponse> {
        return await axios.post(this.URL + '/createPlantInvoice', invoiceDto)
            .then(res => {
                return res.data
            })
    }

    async updatePlantInvoice(invoiceDto: InvoiceDto): Promise<PlantInvoiceCreateResponse> {
        return await axios.post(this.URL + '/updatePlantInvoice', invoiceDto)
            .then(res => {
                return res.data
            })
    }

    async getAllBomDetailsForSoIdInPo(saleOrderId: SaleOrderIdsRequest): Promise<BomDetailsForIdResponseModel> {
        return await axios.post(this.URL + '/getAllBomDetailsForSoIdInPo', saleOrderId)
            .then(res => {
                return res.data
            })
    }

    async GetItemsForBomVendor(saleOrderId: BomIdsRequest): Promise<BomDetailsForIdResponseModel> {
        return await axios.post(this.URL + '/BomDetailsForSoInPackingBom', saleOrderId)
            .then(res => {
                return res.data
            })
    }



    async getBomItemsDetails(itemRequest: ItemRequest): Promise<ItemsDetailsResponseModel> {
        return await axios.post(this.URL + '/getItemsDetails', itemRequest)
            .then(res => {
                return res.data
            })
    }


    async getAllBomDetails(): Promise<GetAllBomDetailsResponseModel> {
        return await axios.post(this.URL + '/getAllBomDetails', undefined)
            .then(res => {
                return res.data
            })
    }
    async getAllBomData(Req: saleOrder): Promise<GetAllBomDataResponseModel> {
        return await axios.post(this.URL + '/getAllBomData', Req)
            .then(res => {
                return res.data
            })
    }

    async getSoNumbers(): Promise<SoNumbersResponseModel> {

        return await axios.post(this.URL + '/getSoNumbersForInvoice')
            .then(res => {
                return res.data
            })
        //   return new SoDropDownResponseModel(true,11,'Food types retrived successfully',[new PoDropDownDto(1,'PO/001'),new PoDropDownDto(2,'PO/002')]);
    }

    async getSoNumbersForPo(req: UnitRequest) {
        return await axios.post(this.URL + '/getSoNumbersForPo', req)
            .then(res => {
                return res.data
            })
    }

    async getSOsAgainstPlant(req?: UnitRequest) {
        return await axios.post(this.URL + '/getSoNumbersForPo', req)
            .then(res => {
                return res.data
            })
    }

    async getSoNumbersForPoFormUpdate() {
        return await axios.post(this.URL + '/getSoNumbersForPoFormUpdate')
            .then(res => {
                return res.data
            })
    }


    async getSaleOrderDataForSoId(saleOrderId: saleOrder): Promise<SaleOrderDropDownDto> {
        return await axios.post(this.URL + '/getSaleOrderDataForSoId', saleOrderId)
            .then(res => {
                return res.data
            })
    }

    /** 
     * get some of the sale order details for sale order id
     * @param saleOrderId
     * @param saleOrderNumber
     * @param poNumber
     * @param category
     * @param dueDate
     * @param status
    */
    async getSaleOrderFewDetailsForSoId(saleOrderId: saleOrder): Promise<SaleOrderFewDetailsDto> {
        return await axios.post(this.URL + '/getSaleOrderFewDetailsForSoId', saleOrderId)
            .then(res => {
                return res.data
            })
    }

    async getSaleOrderItemDetailsBySoItemId(saleOrderItemsRequest: SaleOrderItemsRequest): Promise<SaleOrderItemsBySoIdReaponseModel> {
        return await axios.post(this.URL + '/getSaleOrderItemDetailsBySoItemId', saleOrderItemsRequest)
            .then(res => {
                return res.data
            })
    }

    async getSaleOrderItemsForSo(saleOrderIdRequest: saleOrder): Promise<SaleOrderItemsForSoDropDownResponseModel> {
        return await axios.post(this.URL + '/getSaleOrderItemsForSo', saleOrderIdRequest)
            .then(res => {
                return res.data
            })
    }
    async getSaleOrderItemsForSoId(saleOrderIdRequest: saleOrder): Promise<SaleOrderItemsDropdownResponse> {
        return await axios.post(this.URL + '/getSaleOrderItemsForSoId', saleOrderIdRequest)
            .then(res => {
                return res.data
            })
    }

    async getSaleOrderItemsForSoAndProduct(saleOrderItemsRequest: SaleOrderProductIdRequest): Promise<SaleOrderItemsForSoDropDownResponseModel> {
        return await axios.post(this.URL + '/getSaleOrderItemsForSoAndProduct', saleOrderItemsRequest)
            .then(res => {
                return res.data
            })
    }

    async updateContainerStatus(soContainerStatus: SoContainerStatusUpdate) {
        return await axios.post(this.URL + '/updateContainerStatus', soContainerStatus)
            .then(res => {
                return res.data
            })
    }

    async updateBlStatus(soBlStatus: SoContainerStatusUpdate) {
        return await axios.post(this.URL + '/updateBlStatus', soBlStatus)
            .then(res => {
                return res.data
            })
    }

    async updateSoStatusForBl(soBlStatus: SoContainerStatusUpdate) {
        return await axios.post(this.URL + '/updateSoStatusForBl', soBlStatus)
            .then(res => {
                return res.data
            })
    }

    async getSoTrackInfo(): Promise<AllContainerStatusInfo> {
        return await axios.post(this.URL + '/getSoTrackInfo')
            .then(res => {
                return res.data
            })
    }

    async getSoTrackBlStatusInfo(): Promise<AllBlStatusInfo> {
        return await axios.post(this.URL + '/getSoTrackBlStatusInfo')
            .then(res => {
                return res.data
            })
    }

    async updateBomStats(req: BomIdRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateBomStats', req)
            .then(res => {
                return res.data
            })
    }

    async updatePackingBOM(req: BomUpdateRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updatePackingBOM', req)
            .then(res => {
                return res.data
            })
    }

    async updatePackingBOMGRNData(req: BomUpdateRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updatePackingBOMGRNData', req)
            .then(res => {
                return res.data
            })
    }

    async updatePackingBOMAssignedData(req: BomUpdateRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updatePackingBOMAssignedData', req)
            .then(res => {
                return res.data
            })
    }

    async UpdateSoForPo(saleOrderId: saleOrder): Promise<CommonResponse> {
        return await axios.post(this.URL + '/UpdateSoForPo', saleOrderId)
            .then(res => {
                return res.data
            })
    }

    async getAllPlantInvoiceDetails(req:PlantInvoiceDetailsRequest): Promise<GetAllInvoiceDetailsResponse> {
        return await axios.post(this.URL + '/getAllPlantInvoiceDetails',req)
            .then(res => {
                return res.data
            })
    }

    async getAllFinancialYear(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllFinancialYear')
            .then(res => {
                return res.data
            })
    }

    async ActivateorDeactivateBom(bomReq: BomIdRequest): Promise<BomItemActiveResponse> {
        return await axios.post(this.URL + '/ActivateorDeactivateBom', bomReq)
            .then(res => {
                return res.data
            })
    }
    async Insuranceupload(file: any) {
        console.log(this.URL)
        return await axios.post(this.URL + '/insuranceUpload', file)
            .then(res => {
                return res.data
            })
    }

    async getAllFiles(): Promise<AllInsuranceResponse> {
        return await axios.post(this.URL + '/getAllFiles')
            .then(res => {
                return res.data
            })
    }


    // async assignSo(bomReq:BomIdRequest):Promise<BomItemActiveResponse>{
    //     return await axios.post(this.URL + '/assignSo',bomReq)
    //     .then(res => {
    //         return res.data
    //     })
    // }

    async UpdateBomItemsData(updateBom: UpdateBomItemDto): Promise<BomItemActiveResponse> {
        return await axios.post(this.URL + '/UpdateBomItemsData', updateBom)
            .then(res => {
                return res.data
            })
    }

    async UpdateBomRemovedQty(updateBom: BomItemRemovedQty): Promise<BomItemActiveResponse> {
        return await axios.post(this.URL + '/UpdateBomRemovedQty', updateBom)
            .then(res => {
                return res.data
            })
    }
    async getAllSoDocumentsInfo(plantIdRequest: PlantIdRequest): Promise<GetAllDocApprovalResponse> {
        return await axios.post(this.URL + '/getAllSoDocumentsInfo', plantIdRequest)
            .then(res => {
                return res.data
            })
    }
    async updateDocumentStatus(req: DocumentApprovalUpdateRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateDocumentStatus', req)
            .then(res => {
                return res.data
            })
    }
    async updateDocumentInfo(updateDocumentStatusRequest: UpdateDocumentStatusRequest): Promise<DocumentsApprovalResponse> {
        return await axios.post(this.URL + '/updateDocumentInfo', updateDocumentStatusRequest)
            .then(res => {
                return res.data
            })
    }
    async approveDocument(documentsUploadDto: DocumentsUploadData): Promise<DocumentsApprovalResponse> {
        return await axios.post(this.URL + '/approveDocument', documentsUploadDto)
            .then(res => {
                return res.data
            })
    }
    async updateContainerStatusReadyToBook(containerInfo: DispatchedToPlant) {
        return await axios
            .post(this.URL + '/updateContainerStatusReadyToBook', containerInfo)
            .then((res) => {
                return res.data;
            });
    }

    async updateToOpenStatus(containerInfo: DispatchedToPlant) {
        return await axios
            .post(this.URL + '/updateToOpenStatus', containerInfo)
            .then((res) => {
                return res.data;
            });
    }

    async getRmBomData(req: RMFiltersRequest): Promise<RmBomResponse> {
        return await axios
            .post(this.URL + '/getRmBomData', req)
            .then((res) => {
                return res.data;
            });
    }
    async getAllSoInspections(): Promise<SoInspectionResponseModel> {
        return await axios.post(this.URL + '/getAllSoInspections')
            .then(res => {
                return res.data
            })
    }

    async updateSoInspectionInfo(updateSoInspectionInfoRequest: UpdateSoInspectionRequest): Promise<SoInspectionUpdateResponse> {
        return await axios.post(this.URL + '/updateSoInspectionInfo', updateSoInspectionInfoRequest)
            .then(res => {
                return res.data
            })
    }
    async getReProcessingRequiredQuantity(req: ReProcessRequiredQty) {
        return await axios.post(this.URL + '/getReProcessingRequiredQuantity', req)
            .then(res => {
                return res.data
            })
    }

    async updateReProcessQty(reProcessStock: FGStockData) {
        return await axios.post(this.URL + '/updateReProcessQty', reProcessStock)
            .then(res => {
                return res.data
            })
    }

    async createSoProduction(soProduction: SoProductionDTO): Promise<SoProductionResponseModel> {
        return await axios.post(this.URL + '/createSoProduction', soProduction)
            .then(res => {
                return res.data
            })
    }

    async getAllsaleordersBomdata(): Promise<SORmBomResponse> {
        return await axios.post(this.URL + '/getAllsaleordersBomdata')
            .then(res => {
                return res.data
            })
    }
    async getPackingStyleDetails(saleOrderItemsRequest: SaleOrderItemsRequest): Promise<any> {
        return await axios.post(this.URL + '/getPackingStyleDetails', saleOrderItemsRequest)
            .then(res => {
                return res.data
            })
    }


    async getProductDetailsBySoItemId(saleOrderItemsRequest: SaleOrderItemsRequest): Promise<SaleOrderItemsBySoIdReaponseModel> {
        return await axios.post(this.URL + '/getSaleOrderItemDetailsBySoItemId', saleOrderItemsRequest)
            .then(res => {
                return res.data
            })
    }

    async getSaleOrderItemDetails(saleOrderItemsRequest: SaleOrderItemsRequest): Promise<AllSaleOrdersItemsDetailsResponseModel> {
        return await axios.post(this.URL + '/getSaleOrderItemDetails', saleOrderItemsRequest)
            .then(res => {
                return res.data
            })
    }





    async getVarientInfoForSoItem(saleOrderItemsRequest: saleOrderItemIdRequest): Promise<SoItemVariantResponse> {
        return await axios.post(this.URL + '/getVarientInfoForSoItem', saleOrderItemsRequest)
            .then(res => {
                return res.data
            })
    }

    async getEndCustomerDetails(soRequest: SoRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getEndCustomerDetails', soRequest)
            .then(res => {
                return res.data
            })
    }

    async getHlPercentage(saleOrderItemsRequest: saleOrderItemIdRequest): Promise<HlPercentageInfo> {
        return await axios.post(this.URL + '/getHlPercentage', saleOrderItemsRequest)
            .then(res => {
                return res.data
            })
    }
    async getPoNumbers(): Promise<PoNumberDropDownResponse> {
        return await axios.post(this.URL + '/getPoNumbers')
            .then(res => {
                return res.data
            })
    }

    async getSaleOrdersCountAndQuantity(inputReq: CountRequest): Promise<BomWithCountAndQuantityResponse> {
        return await axios.post(this.URL + '/getSaleOrdersCountAndQuantity', inputReq)
            .then(res => {
                return res.data
            })
    }

    async getSaleOrdersForCount(inputReq: CountRequest): Promise<SoDropCntQtyResponse> {
        return await axios.post(this.URL + '/getSaleOrdersForCount', inputReq)
            .then(res => {
                return res.data
            })
    }
    async getSaleOrdersForRMCount(inputReq: CountRequest): Promise<SoDropCntQtyResponse> {
        return await axios.post(this.URL + '/getSaleOrdersForRMCount', inputReq)
            .then(res => {
                return res.data
            })
    }



    async packingRequirementForMonthly(): Promise<PackingRequiredResponse> {
        return await axios.post(this.URL + '/packingRequirementForMonthly',)
            .then(res => {
                return res.data
            })
    }

    async saveDummyPackmaterial(req: DummyPackBomItemsRequest): Promise<boolean> {
        return await axios.post(this.URL + '/saveDummyPackmaterial', req)
            .then(res => {
                return res.data
            })
    }
    async getSoNumbersForDummyPackAssignment(req: BrandsRequest): Promise<any> {
        return await axios.post(this.URL + '/getSoNumbersForDummyPackAssignment', req)
            .then(res => {
                return res.data
            })
    }

    async savePoBomItems(data: PoBomInfo): Promise<BomDetailsCreationResponseModel> {
        return await axios.post(this.URL + '/savePoBomItems', data)
            .then(res => {
                return res.data
            })
    }
    async updateGrossWeight(req: ItemsDetails[]): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateGrossWeight', req)
            .then(res => {
                return res.data
            })
    }
    async addSoItem(req: SaleOrderItemsInfo): Promise<CommonResponse> {
        return await axios.post(this.URL + '/addSoItem', req)
            .then(res => {
                return res.data
            })
    }
    async updateSoItem(req: SaleOrderItemsInfo): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateSoItem', req)
            .then(res => {
                return res.data
            })
    }
    async getCustInvoiceDetails(req: saleOrder): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getCustInvoiceDetails', req)
            .then(res => {
                return res.data
            })
    }
    async getDocumentApprovalStatus(req: SaleOrderIdRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getDocumentApprovalStatus', req)
            .then(res => {
                return res.data
            })
    }
    async getSoInspectionDetails(req: SaleOrderIdRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getSoInspectionDetails', req)
            .then(res => {
                return res.data
            })
    }
    async updateReproceesingQtyInBom(req: ReprocessingBOMUpdateRequset): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateReproceesingQtyInBom', req)
            .then(res => {
                return res.data
            })
    }
    async getNoOfRackPositionsForSO(req: SaleOrderIdRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getNoOfRackPositionsForSO', req)
            .then(res => {
                return res.data
            })
    }
    async cancelSO(req: SaleOrderIdRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/soCancel', req)
            .then(res => {
                return res.data
            })
    }

    async getSoStatusBySoId(req: SaleOrderIdRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getSoStatusBySoId', req)
    }
    async getBomDataById(req: SaleOrderIdRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getBomDataById', req)
    }

    async PackingBomData(req: PackingBomFilter): Promise<RequiredPackingResponse> {
        return await axios.post(this.URL + '/PackingBomData', req)
            .then(res => {
                return res.data
            })
    }

    async createSubSaleOrder(saleOrderDto: SaleOrderDto): Promise<any> {
        console.log(this.URL)

        return await axios.post(this.URL + '/createSubSaleOrder', saleOrderDto)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async transferSo(req: SoTranferDto): Promise<CommonResponse> {
        console.log(this.URL)

        return await axios.post(this.URL + '/transferSo', req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async getProductForSoId(req: saleOrder): Promise<CommonResponse> {
        console.log(this.URL)

        return await axios.post(this.URL + '/getProductForSoId', req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async getSaleOrdersForGradePattern(req: GradePatternRequest): Promise<CommonResponse> {
        console.log(this.URL)
        return await axios.post(this.URL + '/getSaleOrdersForGradePattern', req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async getSoPackingStatus(req: SoPackingStatusRequest): Promise<SoPackingStatusModel> {
        return await axios.post(this.URL + '/getSoPackingStatus', req)
            .then(res => {
                return res.data
            })
    }
    async getSoDropForSoPackStatusReport(req: UnitRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getSoDropForSoPackStatusReport', req)
            .then(res => {
                return res.data
            })
    }
    async getItemSubDropForSoPackStatusReport(req: UnitRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getItemSubDropForSoPackStatusReport', req)
            .then(res => {
                return res.data
            })
    }
    async getItemDropForSoPackStatusReport(req: UnitRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getItemDropForSoPackStatusReport', req)
            .then(res => {
                return res.data
            })
    }
    async updateReportedAndDispatchCases(req: UpdateCasesRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateReportedAndDispatchCases', req)
            .then(res => {
                return res.data
            })
    }
    async soReport(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/soReport')
            .then(res => {
                return res.data
            })
    }
    async totalSoData(saleOrderTrackFilters: SaleOrderTrackFilters): Promise<CommonResponse> {
        return await axios.post(this.URL + '/totalSoData', saleOrderTrackFilters)
            .then(res => {
                return res.data
            })
    }
    async getEndCustDropForSoReport(req: UnitRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getEndCustDropForSoReport', req)
            .then(res => {
                return res.data
            })
    }
    async getCountryDropForSoReport(req: UnitRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getCountryDropForSoReport', req)
            .then(res => {
                return res.data
            })
    }
    async getManfUintDropForSoReport(req: UnitRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getManfUintDropForSoReport', req)
            .then(res => {
                return res.data
            })
    }
    async getDestinationDropForSoReport(req: UnitRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getDestinationDropForSoReport', req)
            .then(res => {
                return res.data
            })
    }
    async getBrandDropForSoReport(req: UnitRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getBrandDropForSoReport', req)
            .then(res => {
                return res.data
            })
    }
    async getVariantDropForSoReport(req: UnitRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getVariantDropForSoReport', req)
            .then(res => {
                return res.data
            })
    }

    async getTransferredSaleOrders(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getTransferredSaleOrders')
            .then(res => {
                return res.data
            })
    }

    async getSaleOrdersCounDetail(reqObj: UserDateRequest): Promise<SoCountDetailResponse> {
        return await axios.post(this.URL + '/getSaleOrdersCounDetail', reqObj)
            .then(res => {
                return res.data
            })
    }

    async getSaleOrderItemDetailsForSoItemId(saleOrderItemRequest: SaleOrderItemsRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getSaleOrderItemDetailsForSoItemId', saleOrderItemRequest)
            .then(res => {
                return res.data
            })
    }

    async getSOContainerStatus(req: SoRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getSOContainerStatus', req)
            .then(res => {
                return res.data
            })
    }

    async getPackStyleForSoItem(saleOrderItemsRequest: SaleOrderItemsRequest): Promise<any> {
        return await axios.post(this.URL + '/getPackStyleForSoItem', saleOrderItemsRequest)
            .then(res => {
                return res.data
            })
    }

    async getSaleOrdersQtyDetail(reqObj: UserDateRequest): Promise<SoQntDetailResponse> {
        return await axios.post(this.URL + '/getSaleOrdersQtyDetail', reqObj)
            .then(res => {
                return res.data
            })
    }

    async getLongRunSaleOrdersDetail(reqObj: UserDateRequest): Promise<SoLongRunResponse> {
        return await axios.post(this.URL + '/getLongRunSaleOrdersDetail', reqObj)
            .then(res => {
                return res.data
            })
    }
    async getLongRunSoCount(reqObj: UserDateRequest): Promise<SoLongRunResponse> {
        return await axios.post(this.URL + '/getLongRunSoCount', reqObj)
            .then(res => {
                return res.data
            })
    }
    async getTopFiveSaleOrdersDetail(reqObj: UserDateRequest): Promise<SoTopFiveResponse> {
        return await axios.post(this.URL + '/getTopFiveSaleOrdersDetail', reqObj)
            .then(res => {
                return res.data
            })
    }

    async getSaleOrdersComparisonDetail(reqObj: UserDateRequest): Promise<SoComparisonDetailsResponse> {
        return await axios.post(this.URL + '/getSaleOrdersComparisonDetail', reqObj)
            .then(res => {
                return res.data
            })
    }

    async getSaleOrdersDeadStockDetail(reqObj: UserDateRequest): Promise<SoDeadStockDetailsResponse> {
        return await axios.post(this.URL + '/getSaleOrdersDeadStockDetail', reqObj)
            .then(res => {
                return res.data
            })
    }

    async getSaleOrderYearWisePlannedDetail(reqObj: UserDateRequest): Promise<SoYearWisePlanningDetailsResponse> {
        return await axios.post(this.URL + '/getSaleOrderYearWisePlannedDetail', reqObj)
            .then(res => {
                return res.data
            })
    }

    async getSaleOrderYearWiseShippedDetail(reqObj: UserDateRequest): Promise<SoYearWiseShippedDetailsResponse> {
        return await axios.post(this.URL + '/getSaleOrderYearWiseShippedDetail', reqObj)
            .then(res => {
                return res.data
            })
    }

    async getSaleOrderProductionStatusDetail(reqObj: UserDateRequest): Promise<SoProductionStatusDetailsResponse> {
        return await axios.post(this.URL + '/getSaleOrderProductionStatusDetail', reqObj)
            .then(res => {
                return res.data
            })
    }

    async getSoProductionCompleteNotShippedDetail(reqObj: UserDateRequest): Promise<SoProductCompleteNotShippedResponse> {
        return await axios.post(this.URL + '/getSoProductionCompleteNotShippedDetail', reqObj)
            .then(res => {
                return res.data
            })
    }

    async getTotalJobCases(reqObj: SaleOrderIdRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getTotalJobCases', reqObj)
            .then(res => {
                return res.data
            })
    }
    async updateSOStatus(req: SoIdRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateSOStatus', req)
            .then(res => {
                return res.data
            })
    }
    async subJobReverse(req: SaleOrderIdRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/subJobReverse', req)
            .then(res => {
                return res.data
            })
    }

    async getSoLifeCycleStatusCount(req: UnitRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getSoLifeCycleStatusCount', req)
            .then(res => {
                return res.data
            })
    }

    async endcustomerWiseMonthlySOCount(req: EndCustomerReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/endcustomerWiseMonthlySOCount', req)
            .then(res => {
                return res.data
            })
    }
    async getSoDropForSubJob(req: UnitRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getSoDropForSubJob', req)
            .then(res => {
                return res.data
            })
    }
    async editSubJob(req: SubJobRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/editSubJob', req)
            .then(res => {
                return res.data
            })
    }

    async getBrandsForSoId(req: SaleOrderIdRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getBrandsForSoId', req)
            .then(res => {
                return res.data
            })
    }

    async getSaleOrderItemDetailsBySoId(saleOrderItemRequest: SaleOrderIdRequest): Promise<SaleOrderItemsDetailsResponseModel> {
        return await axios.post(this.URL + '/getSaleOrderItemDetailsBySoId', saleOrderItemRequest)
            .then(res => {
                return res.data
            })
    }

    async getSaleOrderDropDownInvoiceDone(req: PlantIdRequest): Promise<SaleOrderDropDownResponseModel> {
        return await axios.post(this.URL + '/getSaleOrderDropDownInvoiceDone', req)
            .then(res => {
                return res.data
            })
    }

    async getTransferredSosReport(req?: TransferredSosFilterDto): Promise<CommonResponse> {
        
        return await axios.post(this.URL + '/getTransferredSosReport', req)
            .then(res => {
                return res.data
            })
    }

    async getDummyItemsForStoreConsumption(req: UnitRequest): Promise<ItemsDetailsResponseModel> {
        return await axios.post(this.URL + '/getDummyItemsForStoreConsumption', req)
            .then(res => {
                return res.data
            })
    }

    async getItemsForStoreConsumption(req: StoreConsumptionItemsRequest): Promise<ItemsDetailsResponseModel> {
        return await axios.post(this.URL + '/getItemsForStoreConsumption', req)
            .then(res => {
                return res.data
            })
    }

    async getSaleordersAbstractReport(saleOrderTrackFilters: SaleOrderTrackFilters): Promise<AllSaleOrdersTrackResponseModel> {
        return await axios.post(this.URL + '/getSaleordersAbstractReport', saleOrderTrackFilters)
            .then(res => {
                return res.data
            })
    }

    async getSoPoBrandDropDownList(req?: UnitRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getSoPoBrandDropDownList', req)
            .then(res => {
                return res.data
            })
    }

    async updateEdlDateInInvoiceDetail(req: EtdWiseDTO[]): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateEdlDateInInvoiceDetail', req)
            .then(res => {
                return res.data
            })
    }
    async getProductBarcode(req: ProductBarcodeRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getProductBarcode', req)
            .then(res => {
                return res.data
            })
    }

    async getCurrentMonthSaleordersForIndentForm(req: SoProcessTypeREQ): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getCurrentMonthSaleordersForIndentForm', req)
            .then(res => {
                return res.data
            })
    }

    async getPackingItemsFormSoItem(req: SoItemReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getPackingItemsFormSoItem', req)
            .then(res => {
                return res.data
            })
    }

    async getRequiredPMQtyForSoItem(req: SoItemReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getRequiredPMQtyForSoItem', req)
            .then(res => {
                return res.data
            })
    }
    async getAllSoForAssignSo(req: SoTypeReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllSoForAssignSo', req)
            .then(res => {
                return res.data
            })
    }
    async getSubJobRevisionCodeListData(req: SubJobSoIdRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getSubJobRevisionCodeListData', req)
            .then(res => {
                return res.data
            })
    }
    async getSubSoData(req: SoItemReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getSubSoData', req)
            .then(res => {
                return res.data
            })
    }
    async updateCodeListStatusInSoTrack(saleOrderId: number): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateCodeListStatusInSoTrack', saleOrderId)
            .then(res => {
                return res.data
            })
    }
    async getsoitemforIndent(req?: UnitRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getsoitemforIndent', req)
            .then(res => {
                return res.data
            })
    }

    async getAllActiveSaleOrdersForCodeList(req: PlantRequest): Promise<SaleOrderDropDownResponseModel> {
        return await axios.post(this.URL + '/getAllActiveSaleOrdersForCodeList', req)
            .then(res => {
                return res.data
            })
    }
    async getTrimsItemsForSo(req: saleOrder): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getTrimsItemsForSo', req)
            .then(res => {
                return res.data
            })
    }

    async updateBomPo(saleOrderId: saleOrder): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateBomPo', saleOrderId)
            .then(res => {
                return res.data
            })
    }
    async GetSoLifeCycleStatusForCategory(req?: SoLifeCycleStatusCategoryReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/GetSoLifeCycleStatusForCategory', req)
            .then(res => {
                return res.data
            })
    }

    async getSaleOrdersForTransfers(req: UnitRequest): Promise<SoNumbersResponseModel> {
        return await axios.post(this.URL + '/getSaleOrdersForTransfers', req)
            .then(res => {
                return res.data
            })
    }
    async getPoNumberForSoId(saleOrderId: saleOrder): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getPoNumberForSoId', saleOrderId)
            .then(res => {
                return res.data
            })
    }

    async updateProductConversionQty(req: ProductConversionReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateProductConversionQty', req)
            .then(res => {
                return res.data
            })
    }

    async updateAssignedAndRequiredQty(req:LocationUpdateRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateAssignedAndRequiredQty', req)
            .then(res => {
                return res.data
            })
    }
    async getEditedSoItemData(req:any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getEditedSoItemData', req)
            .then(res => {
                return res.data
            })
    }

    async getSaleOrderItemsForGradingAssignSo(saleOrderIdRequest: saleOrder): Promise<SaleOrderItemsForSoDropDownResponseModel> {
        return await axios.post(this.URL + '/getSaleOrderItemsForGradingAssignSo', saleOrderIdRequest)
            .then(res => {
                return res.data
            })
    }

    async getFormSdfPrint(req: any): Promise<SaleOrderItemsForSoDropDownResponseModel> {
        return await axios.post(this.URL + '/getFormSdfPrint', req)
            .then(res => {
                return res.data
            })
    }

    async getAnnexureCPrint(req: PlantInvoiceDetailsRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAnnexureCPrint', req)
            .then(res => {
                return res.data
            })
    }

    async getDeclarationForm(req: any): Promise<SaleOrderItemsForSoDropDownResponseModel> {
        return await axios.post(this.URL + '/getDeclarationForm', req)
            .then(res => {
                return res.data
            })
    }
    async createLoadingSheet(req: any): Promise<SaleOrderItemsForSoDropDownResponseModel> {
        return await axios.post(this.URL + '/createLoadingSheet', req)
            .then(res => {
                return res.data
            })
    }


    async getDummySo(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getDummySo')
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async getDomesticSalesGrid(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getDomesticSalesGrid')
        .then(res => {
            return res.data
        }).catch(err => {
            
            return err;
        })
    }
    // async updateDdb(req:PaymentReq): Promise<CommonResponse> {
    //     return await axios.post(this.URL + '/updateDdb',req)
    //         .then(res => {
    //             return res.data
    //         }).catch(err => {
    //             
    //             return err;
    //         })
    // }


    async getDomesticSalesDataForForm(req:any): Promise<DomesticSalesResponseModel> {
        return await axios.post(this.URL + '/getDomesticSalesDataForForm',req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async createDomesticSales(req:DomesticSalesModel): Promise<CommonResponse> {
        return await axios.post(this.URL + '/createDomesticSales',req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async updateDomesticSale(req:DomesticSalesModel[]): Promise<DomesticSalesResponseModel> {
        return await axios.post(this.URL + '/updateDomesticSale',req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    
    
    async getDomesticSalesDataInView(req:any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getDomesticSalesDataInView',req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async getEndCustomersData(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getEndCustomersData')
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }


    async getAllProducts(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllProducts')
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async getAllUnits(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllUnits')
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async getAllUnitManufacturing(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllUnitManufacturing')
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async getDomesticSalesDetailedView(req:any): Promise<DomesticSalesResponseModel> {
        return await axios.post(this.URL + '/getDomesticSalesDetailedView',req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }


    async getEnquiryManagementReport(req:any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getEnquiryManagementReport',req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async getEnquiryManagementReportProductData(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getEnquiryManagementReportProductData')
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }


    async getAllEnquiryNumbers(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllEnquiryNumbers')
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async getInvoiceNumberData(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getInvoiceNumberData')
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async invoiceFileUpload(file: any): Promise<FileUploadResponse> {
        return await axios.post(this.URL + '/invoiceFileUpload', file)
            .then(res => {
                return res.data
            })
      }
    
    async updateColletion(req:PaymentReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateColletion',req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }
    async updateDdb(req:PaymentReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateDdb',req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async getGrossFrozenForInvoiceLogistics(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getGrossFrozenForInvoiceLogistics')
            .then(res => {
                return res.data
            })
    }
    async getConditionsBasedLogistics(req: ConditionsRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getConditionsBasedLogistics',req)
            .then(res => {
                return res.data
            })     
    }

    async getSaleOrderItemsBySaleOrderId(req: SaleOrderIdRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getSaleOrderItemsBySaleOrderId',req)
            .then(res => {
                return res.data
            })     
    }

    async getSoItemPackStyle(req: SOVarientIdReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getSoItemPackStyle',req)
            .then(res => {
                return res.data
            })     
    }

    async getLinerAddressForIsfWorksheet(req: SaleOrderIdRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getLinerAddressForIsfWorksheet',req)
            .then(res => {
                return res.data
            })     
    }
    async updateRodtepStatus(req:RodteStatusReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateRodtepStatus',req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    } 
    async getShipmentDetailsReport(req?:ShipmentDetailRequest): Promise<CommonResponse>{
        return await axios.post(this.URL + '/getShipmentDetailsReport',req)
        .then(res => {
            return res.data
        })     
}

async getCustomerPoForShipmentDetailReport(req:{unitId?:number}): Promise<CommonResponse>{
    return await axios.post(this.URL + '/getCustomerPoForShipmentDetailReport',req)
    .then(res => {
        return res.data
    })     
}

async getBrandForShipmentDetailReport(req:{unitId?:number}): Promise<CommonResponse>{
    return await axios.post(this.URL + '/getBrandForShipmentDetailReport',req)
    .then(res => {
        return res.data
    })     
}

async getInvoiceForShipmentDetailReport(req:{unitId?:number}): Promise<CommonResponse>{
    return await axios.post(this.URL + '/getInvoiceForShipmentDetailReport',req)
    .then(res => {
        return res.data
    })     
}
async getPendingOrdersReport(req:InvoiceRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getPendingOrdersReport',req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async getShippedOrdersReport(req:ShippedDateRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getShippedOrdersReport',req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async getDistinctPoNumbers(req:{unitId?:number}): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getDistinctPoNumbers',req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }


    async getBuyerWiseOrdersReport(req:InvoiceRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getBuyerWiseOrdersReport',req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    
    async getCompleteEnquiryManagementReport(req:any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getCompleteEnquiryManagementReport',req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async getBuyerForEnqReport(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getBuyerForEnqReport')
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async getAgentForEnqReport(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAgentForEnqReport')
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async getSalePersonForEnqReport(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getSalePersonForEnqReport')
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async getEnquiryNumbers(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getEnquiryNumbers')
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async getAllSoInfo(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllSoInfo')
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

        
    
    async getReceivablesBillingData(req: DutyDrawBackDateReq) : Promise<CommonResponse> {
        return await axios.post(this.URL + '/getReceivablesBillingData',req)
        .then(res => {
            return res.data
        }) .catch((err) => {
            return err
        })
    }

    async getReceivablesAgingWiseData(req:DutyDrawBackDateReq) : Promise<CommonResponse> {
        return await axios.post(this.URL + '/getReceivablesAgingWiseData',req)
        .then(res => {
            return res.data
        }) .catch((err) => {
            return err
        })
    }

       async getSuppliersData() : Promise<CommonResponse> {
        return await axios.post(this.URL + '/getSuppliersData')
        .then(res => {
            return res.data
        }) .catch((err) => {
            return err
        })
    }

        async getVendorsData() : Promise<CommonResponse> {
        return await axios.post(this.URL + '/getVendorsData')
        .then(res => {
            return res.data
        }) .catch((err) => {
            return err
        })
    }

     async getFarmerAgingWiseReport(req:DutyDrawBackReportReq) : Promise<CommonResponse> {
        return await axios.post(this.URL + '/getFarmerAgingWiseReport',req)
        .then(res => {
            return res.data
        }) .catch((err) => {
            return err
        })
    }

    async getVendorAgingWiseReport(req:DutyDrawBackReportReq) : Promise<CommonResponse> {
        return await axios.post(this.URL + '/getVendorAgingWiseReport',req)
        .then(res => {
            return res.data
        }) .catch((err) => {
            return err
        })
    }

    async updateSaleReceived(req: SaleReceiveReq) : Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateSaleReceived',req)
        .then(res => {
            return res.data
        }) .catch((err) => {
            return err
        })
    }
    async updateMarksAndNo(req:marksAndNoReq): Promise<CommonResponse> {
        console.log(req,'rrrrrrdddddddd');
        
        return await axios.post(this.URL + '/updateMarksAndNo',req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }
    async updateIgst(req:PaymentReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateIgst',req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }
    async getProductGradeAnalysisReportData(req: ProductGradeReportReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getProductGradeAnalysisReportData',req)
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }
    async getProductGradeAnalysisReportProducts(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getProductGradeAnalysisReportProducts')
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }
    async getProductGradeAnalysisReportGrades(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getProductGradeAnalysisReportGrades')
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async getOverduePendingOrderReport(req:OverDuePendingReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getOverduePendingOrderReport',req)
        .then(res => {
            return res.data
        }).catch(err => {
            
            return err;
        })
}
    async getProductGradeAnalysisReportBuyers(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getProductGradeAnalysisReportBuyers')
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async getMonthWiseOverdueReport(req:OverDuePendingReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getMonthWiseOverdueReport',req)
        .then(res => {
            return res.data
        }).catch(err => {
            
            return err;
        })
}
    async getProductGradeAnalysisReportCountry(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getProductGradeAnalysisReportCountry')
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }
    async getPendingOrdersSummaryReportProduct(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getPendingOrdersSummaryReportProduct')
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }
    async getPendingOrdersSummaryReportCount(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getPendingOrdersSummaryReportCount')
            .then(res => {
                return res.data
            }).catch(err => {
                
                return err;
            })
    }

    async getProductDropdownForScheduleorderReport(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getProductDropdownForScheduleorderReport')
        .then(res => {
            return res.data
        }).catch(err => {
            
            return err;
        })
}

    async getDataForScheduleorderReport(req:scheduleOrderReport): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getDataForScheduleorderReport',req)
        .then(res => {
            return res.data
        }).catch(err => {
            
            return err;
        })
}

async getProductWiseTargetStock(req: ProductWiseTargetStockReq): Promise<CommonResponse> {
    try {
      const res = await axios.post(this.URL + '/getProductWiseTargetStock', req);
      return res.data;
    } catch (err) {
      return err;
    }
  }

  async getSoQuantityAndPayablesDashboard(req: PayablesDashboardReq): Promise<CommonResponse> {
    try {
      const res = await axios.post(this.URL + '/getSoQuantityAndPayablesDashboard', req);
      return res.data;
    } catch (err) {
      return err;
    }
  }
  async getTop10InvAmountVendorsList(req: PaybleComponentReq): Promise<CommonResponse> {
    try {
      const res = await axios.post(this.URL + '/getTop10InvAmountVendorsList', req);
      return res.data;
    } catch (err) {
      return err;
    }
  }

    async getTop10OverdueInvAmountVendorsList(req: PaybleComponentReq): Promise<CommonResponse> {
    try {
        const res = await axios.post(this.URL + '/getTop10OverdueInvAmountVendorsList', req);
        return res.data;
    } catch (err) {
        return err;
    }
  }

  async getShortCodesForProductStockReport(): Promise<CommonResponse> {
    try {
        const res = await axios.post(this.URL + '/getShortCodesForProductStockReport');
        return res.data;
    } catch (err) {
        return err;
    }
  }

  async getGradesForProductStockReport(): Promise<CommonResponse> {
    try {
        const res = await axios.post(this.URL + '/getGradesForProductStockReport');
        return res.data;
    } catch (err) {
        return err;
    }
  }

  async getProductWiseStockReport(req?:ProductWiseStockReq): Promise<CommonResponse> {
    try {
        const res = await axios.post(this.URL + '/getProductWiseStockReport',req);
        return res.data;
    } catch (err) {
        return err;
    }
  }

    async getSaleOrderVarients(): Promise<CommonResponse> {
    try {
        const res = await axios.post(this.URL + '/getSaleOrderVarients');
        return res.data;
    } catch (err) {
        return err;
    }
  }

      async cancelInvoice(req:any): Promise<PlantInvoiceCreateResponse> {
        return await axios.post(this.URL + '/cancelInvoice', req)
            .then(res => {
                return res.data
            })
    }

    async getInvoiceReportData(req?:any): Promise<CommonResponse> {
    try {
        const res = await axios.post(this.URL + '/getInvoiceReportData', req);
        return res.data;
    } catch (err) {
        return err;
    }
  }
    
}



